export const pagesITOperationCoreEn = {
  title: 'IT Operation Core',
  accountRole: 'Account Role',
  accountRoleRequiredError: 'Select an account role for all selected targets before executing.',
  accounts: 'Accounts',
  addPattern: 'Add operation package pattern',
  adminPage: 'Admin/service page',
  allDevices: 'All devices',
  allLabelTypes: 'All label types',
  app: 'App',
  approvalDeadline: 'Approval deadline',
  apps: 'Apps',
  archive: 'Archive',
  assignee: 'Assignee',
  automatedProvisioning: 'Automated provisioning',
  colon: ':',
  complete: 'Complete',
  completed: 'Completed',
  config: 'Config',
  confirm: 'Confirm',
  copiedToClipboard: 'Copied to clipboard',
  copyCredential: 'Copy all the login info',
  correctRole: 'Correct Role',
  credentialNotReady: 'Password is not yet available. Please try again later.',
  data: 'Data',
  detail: 'Detail',
  displayCompact: 'Compact',
  edit: 'Edit',
  emptyDeviceInventoryDescription: 'To start a device inventory, please start a package first.',
  emptyDeviceInventoryTitle: 'No target devices',
  emptyInstanceDescription: 'No operation task found. Please register from the Add operation task button above.',
  emptyInstanceTitle: 'No operation task',
  emptyPackagePatternDescription: 'Please register by clicking the "Add operation package pattern" button.',
  emptyPackagePatternTitle: 'No operation package patterns',
  execute: 'Execute',
  failedToArchive: 'Failed to archive.',
  failedToCompleteTask: 'Failed to complete.',
  failedToDeprovisionAppUser: 'Failed to deprovision app user.\nPlease deactivate/delete the account manually.',
  failedToProvisionAppUser: 'Failed to provision app user.\nPlease create the account manually.',
  failedToStartTaskTitle: 'Failed to start.',
  filterDevices: 'Filter devices...',
  filterPersonApp: 'Search by name or email address',
  goToAdminPageCreate: 'Go to the admin/service page and create the accounts for the listed below.',
  goToAdminPageDeactivate: 'Go to the admin/service page and deactivate the accounts for the listed below.',
  groupBy: 'by {{group}}',
  id: 'ID',
  inclusionInput: {
    disabledTooltip: 'No expiry or purpose needed — role matches the assignment rule',
    expiresAtBeforeAnchorError: 'Set the expiry date on or after both today and the anchor date.',
    expiresAtHeader: 'Expiry Date',
    expiresAtPlaceholder: 'Enter expiry date...',
    expiresAtRequiredError: 'Set an expiry date for any target that has a purpose entered.',
    expiresAtRequiredHint: 'Expiry date is required',
    purposeHeader: 'Purpose of Use',
    purposePlaceholder: 'Enter purpose of use...'
  },
  individualProvisioning: 'Individual provisioning',
  invalid: 'Invalid',
  labelAttachmentWaitingForPrint: 'After the label printing task is completed, the task will be automatically generated after a while.',
  labelGenerated: 'Label generated',
  labelNotGenerated: 'Label not generated',
  labelType: 'Label type',
  letThemKnowPassword: 'Let them know their ID and password for login.',
  license: 'License',
  markAsComplete: 'Mark as complete',
  nonProvisionableRoleWarning: 'This role no longer supports account provisioning. Please choose another role before executing.',
  notApplicable: 'Not applicable',
  openMenu: 'Open menu',
  operationActivity: 'Operation activity',
  operationPackages: 'Operation packages',
  participatingGroups: 'Participating Groups',
  password: 'Password',
  people: 'People',
  person: 'Person',
  pleaseTryAgainLater: 'Please try again later.',
  printOptions: {
    additionalContent: 'Additional content',
    assetTag: 'Asset tag',
    deviceName: 'Device name',
    deviceTag: 'Device tag',
    horizontal: 'Horizontal',
    labelSize: 'Label size',
    layout: 'Layout',
    margin: 'Margin',
    none: 'None',
    paperSize: 'Paper size',
    printSettings: 'Print settings',
    qrCode: 'QR code',
    vertical: 'Vertical'
  },
  processing: 'Processing...',
  productName: 'IT Operation Core',
  progress: 'Progress',
  provisionDate: 'Provision date',
  requestedFor: 'Requested for',
  scheduled: 'Scheduled',
  selectAll: 'Select all',
  selectDate: 'Select date',
  selectRolePlaceholder: 'Select an account role',
  selected: 'Selected',
  setDate: 'Set date',
  setProvisionDate: 'Set the provisioning date for tomorrow or later. It will be executed at 8:00 AM on the set date.',
  showSummary: 'Show summary',
  skip: 'Skip',
  skippedProvisionAppUser: 'Skipped to provision app user.',
  start: 'Confirm targets',
  startNew: 'Start new',
  startToFetchAppUser: 'Start to fetch app user account.',
  successToArchive: 'Archived successfully.',
  successToCompleteTask: 'Succeeded to complete.',
  successToSkip: 'Succeeded to skip.',
  successToStartTaskDescription: 'Please wait for the task to complete.',
  successToStartTaskTitle: 'Succeeded to start.',
  taskProgress: 'Task progress',
  tenantName: 'Tenant name',
  unableToRetrieve: 'Unable to retrieve',
  unknownRole: '(Unknown Account Role)',
  view: 'View',
  viewData: 'View: data',
  violatedRoleWarning: 'This role does not match the assignment rule. It will be registered as an individual inclusion in the rule.',
  waitingForCreatingAppUser: 'Waiting for creating app user account',
  labelSpecs: {
    label24FacesA4: '24 Labels (A4)'
  },
  // 以下は使い回さない想定なので、できる限り構造化していく
  demo: {
    underDevelopment: 'This operation package is currently under development.',
    // Apps
    accountCreationRequest: 'Account creation request',
    accountDeletionRequest: 'Account suspension/deletion request',
    bulkAccountCreation: 'Bulk account creation',
    bulkAccountDeletion: 'Bulk account suspension/deletion',
    emailAddressRequest: 'Email address request',
    licenseRequest: 'License request',
    newSoftwareRequest: 'New software request',
    passwordInitializationRequest: 'Password initialization/reset request',
    sharedIdGroupCreationRequest: 'Shared id group creation request',
    sharedIdGroupJoiningRequest: 'Shared id group joining request',
    softwareInstallationRequest: 'Software installation request',
    systemIntegrationPermissionRequest: 'System integration permission request',
    // Devices
    deviceArrangementRequest: 'Device arrangement request',
    deviceBorrowRequest: 'Device borrow request',
    deviceComputerVirusDetection: 'Computer virus detection/ infection report',
    deviceExchangeRequest: 'Device exchange request',
    deviceInitializationRequest: 'Device initialization request',
    deviceRepairRequest: 'Device repair request',
    deviceSetupRequest: 'Device setup request',
    // Shared Drive
    sharedDriveAccessPermissionRequest: 'Shared drive access permission request',
    sharedDriveCreationRequest: 'Shared drive creation request',
    sharedDriveExternalSharingApplication: 'Shared drive external sharing application',
    // Network
    incidentStatusInvestigationReport: 'Incident status investigation report',
    networkConnectionRequest: 'Network connection request',
    vpnConnectionRequest: 'VPN connection request',
    deviceLossReport: 'Device Loss Report',
    deviceProcurementRequest: 'Device Procurement Request',
    licenseDeactivationRequest: 'License Deactivation Request',
    networkAssignmentRequest: 'Network Assignment Request',
    networkDeactivationRequest: 'Network Deactivation Request',
    simAssignmentRequest: 'SIM Assignment Request',
    simDeactivationRequest: 'SIM Deactivation Request',
    storageAccessDeactivationRequest: 'Folder/Storage Access Removal Request',
    storageAccessRequest: 'Folder/Storage Access Request',
    storageExternalSharingRequest: 'Folder/Storage External Sharing Request',
    vpnAssignmentRequest: 'VPN Assignment Request',
    vpnDeactivationRequest: 'VPN Deactivation Request'
  },
  confirmCompletion: 'Confirm completion',
  csvFileNotReady: 'CSV file is not ready yet.',
  download: 'Download',
  downloadCsv: 'Download CSV',
  downloadPdf: 'Download PDF',
  downloadUrlMissing: 'Download URL is missing.',
  generateCsv: 'Generate CSV',
  generatePdf: 'Generate PDF',
  generatingData: 'Generating data...',
  generatingDataDescription: "This may take tens of seconds.\nPlease wait 5-10 seconds before clicking 'Refresh'.",
  generationCompleted: 'Generation completed',
  generationCompletedWithNextTask: 'Issuance completed. Preparing the next task.\nPlease wait a moment and then refresh the page.',
  pdfGenerationFailed: 'PDF generation failed.',
  popupBlocked: 'Popup was blocked. Please allow popups and try again.',
  retry: 'Retry',
  taskArchivedBeforeFileGeneration: 'This task was archived before file generation.',
  update: 'Refresh',
  device: 'Device',
  labelAttachment: 'Label attachment',
  labelGeneration: 'Label generation',
  labelPrinting: 'Label printing',
  packageProgress: {
    approval: 'Approval',
    inventoryGroupRow: '{{anchorDate}} inventory ({{requestId}})',
    labelAttachment: 'Confirm Label Issuance',
    labelGeneration: 'Inventory Label Issuance',
    reviewResults: 'Self-Report Review',
    selfReport: 'Self-Report',
    selfReportRequest: 'Request Self-Report'
  },
  newRequestDialog: {
    addIndividually: 'Add individually',
    alumniUsers: 'Alumni users',
    cancelButtonLabel: 'Cancel',
    dateLabel: 'Date',
    dateRequired: 'Please select a date.',
    defaultAnchorDateLabel: 'Reference date: Provisioning completion deadline',
    deviceLabel: 'Devices',
    deviceSelectionMode: {
      allUnissued: 'All unissued devices',
      allUnlabeled: 'All unlabeled devices',
      group: 'Select by group',
      selected: 'Select individually'
    },
    displayLimitExceeded: 'Display limit applied due to large number of targets',
    joiningDate: 'Joining date',
    joiningMembers: 'Joining members',
    leavingDate: 'Leaving date',
    leavingMembers: 'Leaving members',
    loading: 'Loading...',
    member: 'Member',
    noJoiningMembers: 'No joining members',
    noLeavingMembers: 'No leaving members',
    noRequiredUsers: 'No required users',
    peopleLabel: 'Targets',
    personRequired: 'Please select at least one person.',
    personSearchPlaceholder: 'Search by name or email address',
    requiredUsers: 'Required users',
    selectPattern: 'Select pattern',
    selectPatternDescription: 'Please select the pattern for this operation package.',
    selectPersonAndDateDescription: 'Please select the target people and reference date.',
    selectTargetPerson: 'Select target person',
    selectTargetPersonDescription: 'Please select the target person.',
    startButtonLabel: 'Start',
    target: 'Target',
    targetPerson: 'Target person',
    title: 'Start a new operation package: {{packageName}}',
    violatedUsers: 'Users to deactivate'
  },
  deviceInventory: {
    toolbar: {
      actions: {
        clearFilters: 'Clear filters',
        export: 'Export CSV',
        refresh: 'Refresh data'
      },
      activeFilters: {
        label: 'Active filters:',
        search: 'Search: "{{query}}"',
        status: 'Status: {{status}}',
        type: 'Type: {{type}}'
      },
      filters: {
        status: {
          all: 'All',
          bad: 'Bad',
          good: 'Good',
          label: 'Status',
          placeholder: 'Status',
          unreported: 'Unreported'
        },
        type: {
          all: 'All',
          assigned: 'Assigned',
          installed: 'Installed',
          label: 'Type',
          placeholder: 'Type'
        }
      },
      search: {
        placeholder: 'Search by device name or tag...'
      },
      summary: {
        devicesReported: '{{reportedDevices}} of {{totalDevices}} devices reported'
      }
    }
  },
  inHousePackages: {
    application: 'Application',
    applicationMockNote: 'Mock data (API pending)',
    confirmation: {
      breadcrumbInHousePackages: 'In-House packages',
      breadcrumbItOperationCore: 'IT Operation Core',
      columns: {
        answeredAt: 'Responded at',
        department: 'Department',
        progress: 'Progress',
        status: 'Status',
        target: 'Requested for'
      },
      downloadCsv: 'Download CSV',
      empty: 'No targets in this group.',
      pageTitle: 'Confirmation',
      status: {
        completed: 'Completed',
        inProgress: 'In progress'
      }
    },
    dataTab: {
      unresolvedPatternDescription: 'The pattern linked to this operation could not be identified. Please reopen it from the package list.',
      unresolvedPatternTitle: 'Unable to display data'
    },
    displayDataAggregate: 'Display: Data aggregate',
    filterByPerson: 'Filter by person',
    ledgerLinkageUnavailableNote: 'Operations created with this feature cannot use ledger linkage or automation triggers.',
    selfReport: 'Self report',
    selfReportPatternConfig: {
      addOption: 'Add option',
      addOther: 'Add "Other"',
      addQuestion: 'Add question',
      approvalFlowDraftPersistHint: 'Approval flow changes are saved with Save draft at the top of the page. They are applied to the live workflow when you publish the pattern.',
      approvalFlowTitle: 'Approval flow',
      approvalFlowValidationError: 'Set a people group for every approval stage before publishing',
      archiveDialog: {
        callout: 'Once archived, this package can no longer be started. This action cannot be undone after archiving.',
        confirmButton: 'Archive',
        description: 'This will archive "{{name}}".',
        title: 'Archive this?'
      },
      breadcrumbInHousePackages: 'In-House packages',
      breadcrumbItOperationCore: 'IT Operation Core',
      createdBy: 'Created by',
      draftSaved: 'Draft saved',
      dueDate: 'Response deadline',
      formatBadge: 'Survey format',
      newPatternLabel: 'New pattern',
      or: 'or',
      otherOptionLabel: 'Other',
      publish: 'Publish pattern',
      publishEmptyOptionsError: 'Enter at least one option for each choice question before publishing',
      publishNoQuestionsError: 'Add at least one question before publishing',
      published: 'Pattern published',
      questionDeleted: 'Question deleted',
      questionLimit: 'You can add up to 10 questions.',
      questionsDescription: 'Add supplementary text as needed',
      questionsTitle: 'Questions',
      required: 'Required',
      saveDraft: 'Save draft',
      status: 'Status',
      statusArchived: 'Archived',
      statusDraft: 'Draft',
      statusPublished: 'Published',
      textAnswerPlaceholder: 'Text answer',
      typeCheckbox: 'Checkbox',
      typeRadio: 'Radio button',
      typeText: 'Text',
      undo: 'Undo',
      updatedAt: 'Updated at',
      updatedBy: 'Updated by'
    },
    startNewDialog: {
      description: 'On the next screens, select targets, enter an optional title, and set an anchor date to start.',
      patternLabel: 'Pattern',
      title: 'Start new self report'
    },
    startTargets: {
      fallbackPatternName: 'Self report',
      selectPerson: 'Select a person',
      start: 'Start',
      title: 'Select targets'
    },
    tab: 'In-House packages'
  },
  tabs: {
    config: 'Config'
  },
  configPage: {
    abortChanges: 'Abort changes',
    anchorDate: 'Anchor date',
    chooseEligibleTargets: 'Choose eligible targets',
    createPeopleGroupIfNeeded: 'Create people group if needed',
    createPeopleGroupIfNotExists: 'If there is no necessary people group, create one.',
    description: 'Description',
    eligiblePeopleGroup: 'Eligible people group',
    eligibleTarget: 'Eligible target',
    openPeopleGroupSettings: 'Open people group settings',
    requestedDate: 'Requested date',
    saveDraft: 'Save draft',
    toPeopleGroup: 'Open people group',
    value: 'Value'
  },
  attached: 'Attached',
  attachmentStatus: 'Attachment status',
  issuanceFormat: 'Issuance format',
  managementLabel: 'Management label',
  notAttached: 'Not attached',
  toast: {
    labelAttachmentFailed: 'Failed to complete label attachment',
    labelAttachmentSuccess: 'Label attachment completed',
    labelAttachmentSuccessDetail: 'Successfully marked {{count}} devices as attached',
    labelGenerationError: 'An unexpected error occurred',
    labelGenerationFailed: 'Failed to generate labels',
    labelGenerationSuccess: 'Label generation completed',
    labelGenerationSuccessDetail: 'Successfully generated {{count}} management labels'
  },
  anchorDate: {
    anchorDateDescription: 'The anchor date is the reference date for executing the operation package.',
    anchorDateLabel: 'Anchor date',
    error: 'Failed to start the operation package.',
    missingInfo: 'Session data is missing',
    missingInfoDescription: 'Please start from the target selection screen.',
    startPackage: 'Start {{packageName}}',
    success: 'Successfully started the operation package.',
    title: '{{packageName}} - Select anchor date'
  },
  deviceTargets: {
    anchorDate: {
      error: 'Failed to start device label issuance.',
      startButton: 'Start device label issuance',
      success: 'Successfully started device label issuance.',
      title: 'Label management - Select scheduled date'
    },
    columns: {
      device: 'Device',
      deviceManagementId: 'Device management ID',
      labelIssuanceStatus: 'Label issuance',
      lastInventoryDate: 'Last inventory date',
      personalOwner: 'Personal owner',
      place: 'Location',
      procurementDate: 'Procurement date',
      responsiblePerson: 'Responsible person',
      serialNumber: 'Serial number',
      status: 'Status',
      userName: 'User name'
    },
    deviceInventoryAnchorDate: {
      error: 'Failed to start device inventory.',
      startButton: 'Start device inventory',
      success: 'Successfully started device inventory.',
      title: 'Device Inventory - Select scheduled date'
    },
    error: 'Failed to load devices',
    errorDescription: 'An error occurred while loading the device list.',
    filters: {
      all: 'All',
      condition: 'Conditions',
      inStock: 'In stock',
      procuredDate: 'Procurement date',
      unlabeledAndInStock: 'Unlabeled devices, In stock',
      unlabeledDevices: 'Unlabeled devices'
    },
    missingPackageInfo: 'Session data is missing',
    missingPackageInfoDescription: 'Please start from the operation package screen.',
    searchPlaceholder: 'Search by device name...',
    title: '{{packageTypeName}} - Select target devices'
  },
  targetSelection: {
    alertCategories: {
      all: 'All',
      // Provisioning
      'deprovisioning-alumni': 'Alumni',
      'deprovisioning-scheduled': 'Scheduled (leaving)',
      // Deprovisioning
      'deprovisioning-violated': 'To deactivate',
      'provisioning-required': 'Required',
      'provisioning-scheduled': 'Scheduled (joining)',
      restructuring: 'Restructuring'
    },
    cannotSelectNoEmail: 'Cannot select: email address is not registered.',
    columns: {
      account: 'Account',
      alertCategory: 'Alert',
      joinedOn: 'Join date',
      leftOn: 'Leave date',
      member: 'Member',
      restructuringPlanNames: 'Restructuring plan'
    },
    contextBar: {
      anchorDate: 'Anchor date',
      pattern: 'Pattern',
      software: 'Software'
    },
    correctRoleFilter: {
      clearAriaLabel: 'Clear correct role filter',
      label: 'Correct Role',
      searchPlaceholder: 'Search by role name...',
      unassigned: 'Unassigned'
    },
    deprovisioningTitle: '{{packageName}} - Select targets',
    manualProvisioningSubtitle: 'Select Targets',
    manualProvisioningTitle: 'Bulk Account Provisioning - Immediate',
    provisioningTitle: '{{packageName}} - Select targets',
    restructuringPlan: 'Restructuring',
    restructuringPlanFilterClearAriaLabel: 'Clear restructuring filter',
    restructuringPlanSearchPlaceholder: 'Search by restructuring...',
    searchPlaceholder: 'Filter People...',
    softwareProvisioningTitle: '{{packageName}}: {{softwareName}} — Select targets',
    startError: 'Failed to start the operation package.',
    startManualProvisioning: 'Start Bulk Provisioning',
    startPackage: 'Start {{packageName}}',
    startSuccess: 'Successfully started the operation package.'
  }
};